/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-09 08:56:31
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import type { DashboardState, DashboardAction } from 'stores/flow-type/dashboard.type';

import {
  GET_DASHBOARD_BLOCKS_REQUEST,
  GET_DASHBOARD_BLOCKS_SUCCESS,
  GET_DASHBOARD_BLOCKS_FAILURE,
  GET_DASHBOARD_COMPONENTS_REQUEST,
  GET_DASHBOARD_COMPONENTS_SUCCESS,
  GET_DASHBOARD_COMPONENTS_FAILURE,
  FEEDBACK_REQUEST,
  FEEDBACK_SUCCESS,
  FEEDBACK_FAILURE,
  PROCESS_DISMISS_BLOCK_REQUEST,
  PROCESS_DISMISS_BLOCK_SUCCESS,
  PROCESS_DISMISS_BLOCK_FAILURE,
  UNDO_DISMISS_BLOCK_REQUEST,
  UNDO_DISMISS_BLOCK_SUCCESS,
  UNDO_DISMISS_BLOCK_FAILURE,
  CONFIRM_DISMISS_BLOCK,
  UPDATE_DASHBOARD_BLOCK
} from 'stores/flow-type/dashboard.type';

const initialState: DashboardState = {
  loading: false,
  success: false,
  dashboardComponentsLoading: false,
  dashboardComponentsSuccess: false,
  feedbackLoading: [],
  feedbackSuccess: [],
  dismissLoading: [],
  dismissSuccess: [],
  error: undefined,
  dashboardBlocks: {},
  dashboardComponents: {}
};

const dashboardReducers = (state: DashboardState = initialState, action: DashboardAction) => {
  switch (action.type) {
    case GET_DASHBOARD_BLOCKS_REQUEST:
      return { ...state, loading: true };
    case PROCESS_DISMISS_BLOCK_REQUEST:
    case UNDO_DISMISS_BLOCK_REQUEST: {
      const { blockName } = action.payload;
      const dismissLoading = [...state.dismissLoading, blockName];

      return { ...state, dismissLoading };
    }
    case FEEDBACK_REQUEST: {
      const { blockName } = action.payload;
      const feedbackLoading = [...state.feedbackLoading, blockName];
      return { ...state, feedbackLoading };
    }
    case GET_DASHBOARD_BLOCKS_SUCCESS: {
      const { data } = action.payload;

      return { ...state, loading: false, error: undefined, dashboardBlocks: data };
    }
    case FEEDBACK_SUCCESS: {
      const { blockName } = action.payload;

      // Remove loading status and update feedback status for selected block
      const feedbackLoading = _.remove(state.feedbackLoading, blockName);
      const feedbackSuccess = [...state.feedbackSuccess, blockName];

      return { ...state, feedbackLoading, feedbackSuccess };
    }
    case PROCESS_DISMISS_BLOCK_SUCCESS:
    case UNDO_DISMISS_BLOCK_SUCCESS: {
      const { blockName, data } = action.payload;
      const dismissLoading = _.remove(state.dismissLoading, blockName);
      const dismissSuccess = [...state.dismissSuccess, blockName];

      return { ...state, dismissLoading, error: undefined, dismissSuccess, dashboardBlocks: data };
    }
    case GET_DASHBOARD_BLOCKS_FAILURE:
      const { data } = action.payload;

      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
        dashboardBlocks: data
      };
    case FEEDBACK_FAILURE: {
      const { blockName } = action.payload;
      const feedbackLoading = _.remove(state.feedbackLoading, blockName);

      return { ...state, feedbackLoading, error: action.payload };
    }
    case PROCESS_DISMISS_BLOCK_FAILURE:
    case UNDO_DISMISS_BLOCK_FAILURE: {
      const { blockName } = action.payload;
      const dismissLoading = _.remove(state.dismissLoading, blockName);

      return {
        ...state,
        dismissLoading,
        error: action.payload
      };
    }
    case CONFIRM_DISMISS_BLOCK: {
      const { blockName } = action.payload;
      return {
        ...state,
        dashboardBlocks: { ...state.dashboardBlocks, [blockName]: false }
      };
    }
    case UPDATE_DASHBOARD_BLOCK: {
      const { blocks } = action.payload;

      return {
        ...state,
        dashboardBlocks: { ...state.dashboardBlocks, ...blocks }
      };
    }
    case GET_DASHBOARD_COMPONENTS_REQUEST:
      return { ...state, dashboardComponentsLoading: true, dashboardComponentsSuccess: false };
    case GET_DASHBOARD_COMPONENTS_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        dashboardComponentsLoading: false,
        dashboardComponentsSuccess: true,
        error: undefined,
        dashboardComponents: data
      };
    }
    case GET_DASHBOARD_COMPONENTS_FAILURE:
      return {
        ...state,
        dashboardComponentsLoading: false,
        dashboardComponentsSuccess: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default dashboardReducers;
